import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const FORM_CONTENT_BLOCKER_CONTEXT_SYMBOL = Symbol();
const useFormContentBlocker = ()=>useImmutableContext(FORM_CONTENT_BLOCKER_CONTEXT_SYMBOL);
const useFormContentBlockerProvider = (...args)=>useImmutableContextProvider(FORM_CONTENT_BLOCKER_CONTEXT_SYMBOL, ...args);
export { useFormContentBlocker, useFormContentBlockerProvider };
